import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import { InfoRow } from './InfrastructureSectionPanel';

const InfrastructureCpuPanel = ({ data }) => (
    <Row className="g-3">
        <Col md={4}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Hardware</div>
                    <InfoRow label="Model" value={data.model} />
                    <InfoRow label="Cores" value={data.cores} />
                    <InfoRow label="Speed" value={data.speed} />
                </Card.Body>
            </Card>
        </Col>
        <Col md={4}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Load Average</div>
                    <InfoRow label="1 min" value={data.loadAverage?.['1min']} />
                    <InfoRow label="5 min" value={data.loadAverage?.['5min']} />
                    <InfoRow label="15 min" value={data.loadAverage?.['15min']} />
                </Card.Body>
            </Card>
        </Col>
        <Col md={4}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Process CPU Usage</div>
                    <InfoRow label="User (s)" value={data.processUsage?.userSeconds} />
                    <InfoRow label="System (s)" value={data.processUsage?.systemSeconds} />
                    <InfoRow label="User (µs)" value={data.processUsage?.userMicroseconds} />
                    <InfoRow label="System (µs)" value={data.processUsage?.systemMicroseconds} />
                </Card.Body>
            </Card>
        </Col>
        {data.perCore?.length > 0 && (
            <Col xs={12}>
                <Card className="border-0 bg-light">
                    <Card.Body className="py-2 px-3">
                        <div className="small fw-semibold mb-2 text-secondary">Per-Core Times (ms)</div>
                        <div className="table-responsive">
                            <Table size="sm" className="mb-0 small">
                                <thead>
                                    <tr>
                                        <th>Core</th>
                                        <th>Speed (MHz)</th>
                                        <th>User</th>
                                        <th>Nice</th>
                                        <th>Sys</th>
                                        <th>Idle</th>
                                        <th>IRQ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.perCore.map((c) => (
                                        <tr key={c.core}>
                                            <td>{c.core}</td>
                                            <td>{c.speed}</td>
                                            <td>{c.times?.user}</td>
                                            <td>{c.times?.nice}</td>
                                            <td>{c.times?.sys}</td>
                                            <td>{c.times?.idle}</td>
                                            <td>{c.times?.irq}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        )}
    </Row>
);

export default InfrastructureCpuPanel;
